import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CompanyID from '@/App/Company/Entity/CompanyID'
import OnboardingID from '@/App/Company/Entity/OnboardingID'
import type {
    BookingReasonEnum,
    OnboardingRawData,
    PreDefinedAvailabilityTypeEnum,
} from '@/Shared/AutoGenerated/Main'

export default class Onboarding {
    constructor(
        public readonly id: OnboardingID,
        public readonly companyId: CompanyID,
        public readonly step: string,
        public readonly surveyBookingReason: BookingReasonEnum | null,
        public readonly surveyBookingReasonDescription: string | null,
        public readonly surveyPreDefinedAvailabilityType: PreDefinedAvailabilityTypeEnum | null,
        public readonly surveyPreviousSchedulingTool: string | null,
        public readonly surveyWebsiteUrl: string | null,
        public readonly surveyIndustry: string | null,
        public readonly surveyNumberOfEmployees: string | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrateSingle(entityData: OnboardingRawData): Onboarding {
        return new Onboarding(
            new OnboardingID(entityData.id),
            new CompanyID(entityData.companyId),
            entityData.step,
            entityData.surveyBookingReason,
            entityData.surveyBookingReasonDescription,
            entityData.surveyPreDefinedAvailabilityType,
            entityData.surveyPreviousSchedulingTool,
            entityData.surveyWebsiteUrl,
            entityData.surveyIndustry,
            entityData.surveyNumberOfEmployees,
        )
    }
}
